import { useCallback } from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { LIVE_SESSION_NS } from '../components/BunkeringDashboard/i18n';
import { downloadBlobAsFile } from '@diana/core';
import { RefetchOptions, RefetchQueryFilters, QueryObserverResult } from '@tanstack/react-query';

type RefetchFunction = <TPageData>(
  options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
) => Promise<QueryObserverResult<any, unknown>>;

const useHandleExport = (refetch: RefetchFunction) => {
  const { t } = useTranslation([LIVE_SESSION_NS]);

  return useCallback(async (fileName?: string) => {
    try {
      const { data } = await refetch();
      if (data) {
        const date = DateTime.now().toFormat('yyyyMMddHHmmss');
        const defaultFileName = t('components/BunkeringDashboard:exportFileName', { date });
        downloadBlobAsFile(data, `${fileName || defaultFileName}.csv`);
      } else {
        throw new Error('No data received from export');
      }
    } catch (error) {
      console.error('Export error:', error);
      throw error; // Re-throw to be caught by component
    }
  }, [refetch, t]);
};

export default useHandleExport;
